import {
  CELL_BROKER_HIGHLIGHT_BG,
  CELL_NEEDS_REVIEW_BG,
  useCellReviews,
} from "@platform/btx-plan-designer";

import type { CellReviewCellIdentity } from "./useCellReviewContextMenu";

export interface CellReviewCellStyle {
  backgroundColor: string;
  comment?: string | null;
}

/**
 * Resolves the "Needs Review" (yellow) / "Highlight" (blue) background tint
 * and the comment for a cell, given its {planId, fieldPath} identity.
 * Shared by every tab's carrier-column cell renderer (Comps, Responses); each
 * renderer stays concretely typed to its own row/column shape and only
 * delegates this lookup + color mapping.
 */
export const useCellReviewCellStyle = (
  cell: CellReviewCellIdentity | null,
): CellReviewCellStyle => {
  const cellReviews = useCellReviews();
  const review = cell
    ? cellReviews.getReview(cell.planId, cell.fieldPath)
    : undefined;
  const hasBrokerHighlight = cell
    ? cellReviews.getBrokerHighlight(cell.planId, cell.fieldPath)
    : false;

  return {
    backgroundColor: review
      ? CELL_NEEDS_REVIEW_BG
      : hasBrokerHighlight
        ? CELL_BROKER_HIGHLIGHT_BG
        : "transparent",
    comment: review?.comment,
  };
};
